import React, { useState } from 'react';

const HT = {
  yellow: '#FFD166', yellowSoft: '#FFE9A8', yellowBg: '#FFF8E7',
  green: '#88C057', greenDark: '#5E9E3E', greenSoft: '#D4E8C0', greenBg: '#E8F3D9',
  coral: '#FF8C42', coralDark: '#E76F51', coralPress: '#B8431E',
  pinkBg: '#FCE4E8', pink: '#F4A6B8',
  brown: '#8B6F47', brownDark: '#6B4F2B',
  text: '#2D2D2D', textSoft: '#6B6B6B', textMuted: '#9A9A9A',
  border: '#E8E0CC', white: '#FFFFFF',
};
const FONT_DISPLAY = '"Fredoka", "Baloo 2", "Nunito", sans-serif';
const FONT_BODY = '"Nunito", "Baloo 2", sans-serif';

// Persist flip state across cards in the same JS session — once a kid flips to
// the back, the next card stays on back until they click to flip again.
let _flipPreference = false;

export default function VocabFlashcard({ payload, onAnswer, disabled }) {
  const [flipped, setFlipped] = useState(_flipPreference);
  const front = payload.front || {};
  const back = payload.back || {};
  const isLocked = !!disabled;

  const toggleFlip = () => {
    if (isLocked) return;
    setFlipped(v => {
      _flipPreference = !v;
      return !v;
    });
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', fontFamily: FONT_BODY }}>
      <div
        onClick={toggleFlip}
        style={{
          position: 'relative',
          minHeight: 420,
          borderRadius: 24,
          background: flipped
            ? `linear-gradient(180deg, ${HT.yellowBg} 0%, ${HT.pinkBg} 100%)`
            : `linear-gradient(180deg, ${HT.yellowBg} 0%, ${HT.greenBg} 100%)`,
          border: `2px dashed ${flipped ? HT.coral : HT.yellow}`,
          cursor: isLocked ? 'default' : 'pointer',
          padding: 28,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'background 0.3s, border-color 0.3s',
        }}
      >
        {/* Flip hint chip */}
        {!isLocked && (
          <div style={{
            position: 'absolute', top: 14, right: 14,
            padding: '4px 12px', borderRadius: 999,
            background: HT.white, border: `1px solid ${HT.border}`,
            fontSize: 11, fontWeight: 700, color: HT.textSoft,
            fontFamily: FONT_DISPLAY, letterSpacing: 0.5,
            display: 'inline-flex', alignItems: 'center', gap: 4,
          }}>
            🔄 Bấm để lật
          </div>
        )}

        {!flipped ? (
          <>
            {front.image_url ? (
              <img
                src={front.image_url}
                alt={front.word}
                style={{
                  maxHeight: 220,
                  maxWidth: '100%',
                  borderRadius: 16,
                  marginBottom: 16,
                  filter: 'drop-shadow(0 6px 12px rgba(139,111,71,0.18))',
                }}
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            ) : null}
            <div style={{
              fontSize: 'clamp(40px, 5.5vw, 60px)', fontWeight: 700,
              fontFamily: FONT_DISPLAY, color: HT.text, lineHeight: 1.05,
              letterSpacing: -1,
            }}>
              {front.word}
            </div>
            {front.pronunciation_uk ? (
              <div style={{
                marginTop: 8, fontSize: 18, color: HT.textSoft,
                fontFamily: 'monospace',
              }}>
                {front.pronunciation_uk}
              </div>
            ) : null}
            {front.pos ? (
              <div style={{
                marginTop: 6, fontStyle: 'italic',
                color: HT.textMuted, fontSize: 14, fontWeight: 600,
              }}>
                ({front.pos})
              </div>
            ) : null}
          </>
        ) : (
          <>
            <div style={{
              fontSize: 'clamp(28px, 3.5vw, 38px)', fontWeight: 700,
              fontFamily: FONT_DISPLAY, color: HT.coralDark, lineHeight: 1.1,
            }}>
              {back.name_vi}
            </div>
            {back.definition_vi ? (
              <div style={{
                marginTop: 12, color: HT.text, fontSize: 16, fontWeight: 600,
                lineHeight: 1.5, maxWidth: 460,
              }}>
                {back.definition_vi}
              </div>
            ) : null}
            {back.example_en ? (
              <div style={{
                marginTop: 18, padding: '14px 18px',
                background: HT.white, borderRadius: 14,
                border: `1px solid ${HT.border}`,
                maxWidth: 460,
              }}>
                <div style={{ fontSize: 16, fontWeight: 600, color: HT.text, fontStyle: 'italic' }}>
                  "{back.example_en}"
                </div>
                {back.example_vi ? (
                  <div style={{ fontSize: 14, color: HT.textSoft, marginTop: 6, fontWeight: 600 }}>
                    {back.example_vi}
                  </div>
                ) : null}
              </div>
            ) : null}
          </>
        )}
      </div>

      {!isLocked ? (
        <div style={{ display: 'flex', gap: 12, marginTop: 18, justifyContent: 'center' }}>
          <button
            onClick={() => onAnswer && onAnswer({ is_correct: false, user_answer: 'unknown' })}
            style={btn(HT.coral, HT.coralPress)}
          >
            🤔 Chưa biết
          </button>
          <button
            onClick={() => onAnswer && onAnswer({ is_correct: true, user_answer: 'known' })}
            style={btn(HT.green, HT.greenDark)}
          >
            ✨ Đã biết
          </button>
        </div>
      ) : null}
    </div>
  );
}

function btn(bg, shadowColor) {
  return {
    padding: '14px 26px',
    border: 'none',
    borderRadius: 14,
    background: bg,
    color: HT.white,
    fontSize: 16,
    fontWeight: 700,
    fontFamily: FONT_DISPLAY,
    cursor: 'pointer',
    boxShadow: `0 4px 0 ${shadowColor}`,
    transition: 'transform 0.1s, box-shadow 0.1s',
    minWidth: 150,
  };
}
